import { Fee } from 'app/shared/model/Fee';
import { SelectionMap } from 'app/shared/model/ProductFilter';
import * as React from 'react';
import { StackedTransferSelector } from 'app/pages/DiscountEditor/components/StackedTransferSelector';
import { isFeeSelected } from 'app/pages/DiscountEditor/modules/DiscountActions/feeCodes';

interface FeeSelectionEditorProps { 
    fees: Fee[],
    selectedFees: SelectionMap,
    feeSelectionChanged: (fees: SelectionMap) => void
}

export const FeeSelectionEditor = (props: FeeSelectionEditorProps) => {
    const feesToShow = props.fees
        .filter(f => f.active || isFeeSelected(f, props.selectedFees));

    return (
        <div>
            <StackedTransferSelector
                items={feesToShow.map(f => ({
                    key: String(f.id),
                    title: f.name,
                }))}
                targetKeys={feesToShow
                    .filter(f => isFeeSelected(f, props.selectedFees))
                    .map(f => String(f.id))}
                onChange={nextKeys => changeFeeSelection(nextKeys, props)}
                availableTitle="All fees"
                selectedTitle="Selected fees"
                searchPlaceholder="Search by name..."
                height={220}
            />
        </div>
    );
};

function changeFeeSelection(selectedKeys: string[], ownProps: FeeSelectionEditorProps) {
    const newSelection: SelectionMap = {};
    selectedKeys.forEach(key => {
        newSelection[key] = true;
    });

    ownProps.feeSelectionChanged(newSelection);
}
